import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './Transfer.module.css';
import { Arrows } from '../Arrows';

const bindClasses = classNameBind.bind(styles);

class Transfer extends React.Component {
  static defaultProps = {
    onChange: () => {},
    disabled: false,
    value: [],
    options: [],
    componentLeft: {
      failedMessage: '',
      error: '',
      isLoading: false,
    },
    componentRight: {
      failedMessage: '',
      error: '',
      isLoading: false,
    },
  }

  constructor(props) {
    super(props);

    this.state = {
      left: {
        value: [],
      },
      right: {
        value: [],
        searchValue: '',
        pagination: {
          limit: props.componentRight.pagination.limit,
          offset: 0,
        },
      },
    };
  }

  handleLeftChange = (event) => {
    const { options } = this.props;

    this.setState((prevState) => {
      const value = event.target.value.map((element) => {
        const elementInPreviousState = prevState[event.target.name].value.find(
          obj => obj.id === element,
        );
        const elementInOptions = options.find(obj => obj.id === element);

        return elementInPreviousState || elementInOptions;
      });

      return {
        [event.target.name]: {
          ...prevState[event.target.name],
          value,
        },
      };
    });
  }

  handleRightChange = (event) => {
    const { value } = this.props;

    this.setState((prevState) => {
      const result = event.target.value.map((element) => {
        const elementInPreviousState = prevState[event.target.name].value.find(
          obj => obj.id === element,
        );
        const elementInOptions = value.find(obj => obj.id === element);

        return elementInPreviousState || elementInOptions;
      });

      return {
        [event.target.name]: {
          ...prevState[event.target.name],
          value: result,
        },
      };
    });
  }

  handleRightSearchChange = (event) => {
    const { value } = event.target;
    const { componentRight } = this.props;

    componentRight.search.onChange(event);

    this.setState(prevState => ({
      right: {
        ...prevState.right,
        pagination: {
          ...prevState.right.pagination,
          offset: 0,
        },
        searchValue: value,
      },
    }));
  }

  filterWithSearch = records => (
    records
      .filter(
        element => element.name
          .toLowerCase()
          // eslint-disable-next-line react/destructuring-assignment
          .includes(this.state.right.searchValue.toLowerCase()),
      )
  )

  handleAddValue = () => {
    const {
      onChange,
      value,
      name,
    } = this.props;
    const { left } = this.state;

    onChange({
      target: {
        name,
        value: value.concat(left.value),
      },
    });

    this.setState({
      left: {
        ...left,
        value: [],
      },
    });
  }

  handleRemoveValue = () => {
    const { onChange, value, name } = this.props;
    const { right } = this.state;

    onChange({
      target: {
        name,
        value: value.filter(element => !right.value.some(option => option.id === element.id)),
      },
    });

    this.setState({
      right: {
        ...right,
        value: [],
      },
    });
  }

  getResultsForSide = (side) => {
    const { options, value } = this.props;
    let result = [];

    if (side === 'left') {
      result = options
        .map(option => (value.filter(element => element.id === option.id).length > 0
          ? {
            ...option,
            side: 'left',
            disabled: true,
          }
          : {
            ...option,
            side: 'left',
            disabled: false,
          }));
    } else {
      result = value.map(singleValue => ({
        ...singleValue,
        side: 'right',
      }));
    }

    return result;
  }

  renderComponent(componentProps, side) {
    const { Component, customListColumns, rightInfoChildren } = this.props;
    const { right } = this.state;
    const options = {
      left: this.getResultsForSide('left'),
      right: this.getResultsForSide('right'),
    };

    const filteredRightOptions = this.filterWithSearch(options.right);

    return (
      <Component
        name={side}
        id={side}
        side={side}
        customListColumns={customListColumns}
        rightInfoChildren={rightInfoChildren}
        // eslint-disable-next-line
        value={this.state[side].value.map(element => element.id)}
        search={{
          value: side === 'right'
            ? right.searchValue
            : componentProps.search.value,
          placeholder: componentProps.search.placeholder,
          onChange: side === 'right'
            ? this.handleRightSearchChange
            : componentProps.search.onChange,
        }}
        pagination={{
          onChange: componentProps.pagination.onChange,
          limit: componentProps.pagination.limit,
          offset: componentProps.pagination.offset,
          total: side === 'right'
            ? filteredRightOptions.length
            : componentProps.pagination.total,
          limitOptions: componentProps.pagination.limitOptions,
        }}
        options={side === 'right'
          ? filteredRightOptions
          : options.left
        }
        onChange={side === 'right'
          ? this.handleRightChange
          : this.handleLeftChange
        }
        header={componentProps.header}
        disabled={componentProps.disabled}
        error={componentProps.error}
        failedMessage={componentProps.failedMessage}
        isLoading={componentProps.isLoading}
      />
    );
  }

  render() {
    const {
      disabled,
      componentLeft,
      componentRight,
    } = this.props;
    const {
      left,
      right,
    } = this.state;

    return (
      <div className={bindClasses('wrapper')}>
        <div className={bindClasses('list', 'leftList')}>
          {this.renderComponent(componentLeft, 'left')}
        </div>
        <Arrows
          leftArrowDisabled={disabled || right.value.length === 0}
          leftArrowOnClick={this.handleRemoveValue}
          rightArrowDisabled={disabled || left.value.length === 0}
          rightArrowOnClick={this.handleAddValue}
        />
        <div className={bindClasses('list', 'rightList')}>
          {this.renderComponent(componentRight, 'right')}
        </div>
      </div>
    );
  }
}

export default Transfer;
